import { Avatar, Table, Modal, Flex, Badge } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { deleteEmployee, getEmployeeList } from "../../api/employeeApi";
import EmployeesUpdateForm from "./EmployeesUpdateForm";
import { deleteNotification } from "../../utils/useNotification";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import TableEditButton from "../common/Buttons/TableEditButton";
import styled from "styled-components";
import AreYouSureModal from "../common/Modals/AreYouSureModal";
import TableInfoButton from "../common/Buttons/TableInfoButton";
import CustomSelect from "../common/Inputs/CustomSelect";
import CustomSearchInput from "../common/Inputs/CustomSearchInput";
import CustomPagination from "../common/CustomPagination";
import { Employee } from "../../types/types";
import { useAuth } from "../../context/AuthContext";

const EmployeesTable = () => {
  const { roleSelectData, departmentSelectData } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const [tableData, setTableData] = useState<any>();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [, setTotalItems] = useState(0);
  //for modal
  const [opened, setOpened] = useState(false);
  const [clickedUser, setClickedUser] = useState<any>();
  //for delete modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  //for department select
  const [selectedDepartment, setSelectedDepartment] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();
  //for active-inactive selet
  const [selectedActiveness, setSelectedActiveness] = useState<boolean>();
  //for position select
  const [selectedPosition, setSelectedPosition] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getEmployeeList({
        pageNumber: page,
        limit: limit,
        sort,
        department: selectedDepartment,
        name: searchedName,
        isWorkingCurrently: selectedActiveness,
        role: selectedPosition,
      });
      if (data.success) {
        setTableData(data?.data);
        setPage(data?.meta?.page);
        setLimit(data?.meta?.limit);
        setTotalPages(data?.meta?.totalPages);
        setTotalItems(data?.meta?.total);
      } else {
        //fetch işlemi başarısız
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [
    page,
    opened,
    sort,
    selectedDepartment,
    searchedName,
    selectedActiveness,
    selectedPosition,
  ]);

  const handleDeleteClick = async (id: any) => {
    try {
      const { data }: any = await deleteEmployee({ id });
      deleteNotification(data?.success);
      const { data: updatedList }: any = await getEmployeeList({
        pageNumber: page,
        limit: limit,
      });
      setTableData(updatedList?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            height: "60vh",
            width: "100%",
            border: "1px solid #D1D5DB",
            borderRadius: "6px",
          }}
        >
          <Flex p={"12px 16px"} justify={"space-between"}>
            <CustomSearchInput
              placeholder="Ad Soyad"
              w={220}
              value={searchedName}
              onChange={(event: any) => {
                setPage(1);
                setSearchedName(event.currentTarget.value);
              }}
            />
            <Flex gap={8}>
              <CustomSelect
                placeholder="Departman"
                data={departmentSelectData}
                onChange={(e: any) => {
                  setSelectedDepartment(e);
                  setPage(1);
                }}
              />
              <CustomSelect
                placeholder="Rol"
                data={roleSelectData}
                onChange={(e: any) => {
                  setSelectedPosition(e);
                  setPage(1);
                }}
              />
              <CustomSelect
                placeholder="Çalışma Durumu"
                data={[
                  { label: "Çalışıyor", value: "active" },
                  { label: "Ayrıldı", value: "inactive" },
                ]}
                onChange={(e: any) => {
                  setSelectedActiveness(
                    e === "active" ? true : e === "inactive" ? false : undefined
                  );
                }}
              />
            </Flex>
          </Flex>
          <Table
            style={{
              borderCollapse: "separate",
            }}
            highlightOnHover
            verticalSpacing="sm"
          >
            <Table.Thead
              style={{
                background: "#EEF2FF",
              }}
            >
              <Table.Tr>
                <StyledTableTh style={{ width: "25%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Ad Soyad</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "25%" }}>Telefon</StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>
                  Departman
                </StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>Rol</StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>
                  Çalışma Durumu
                </StyledTableTh>
                <StyledTableTh style={{ width: "5%" }}></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((employee: Employee) => (
                <StyledTableTr
                  onClick={() => {
                    navigate(`/employees/${employee?._id}`, {
                      state: window?.location?.pathname,
                    });
                  }}
                  key={employee?._id}
                  style={{
                    color: "#111827",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  <Table.Td>
                    <Flex justify={"start"} align={"center"} gap={16}>
                      <Badge
                        style={{ cursor: "pointer", minWidth: "40px" }}
                        circle
                        bg={"#EEF2FF"}
                        size={"40px"}
                      >
                        <AvatarText>{employee?.name[0]}</AvatarText>
                      </Badge>
                      {employee?.name}
                    </Flex>
                  </Table.Td>
                  <Table.Td>{employee?.phone}</Table.Td>
                  <Table.Td>
                    {employee?.departments && employee.departments.length > 1
                      ? "Birden fazla"
                      : employee?.departments?.[0]?.label ||
                        "Departman bilgisi yok"}
                  </Table.Td>
                  <Table.Td>
                    {employee?.roles && employee.roles.length > 1
                      ? "Birden fazla"
                      : employee?.roles?.[0]?.label || "Rol bilgisi yok"}
                  </Table.Td>
                  <Table.Td>
                    {employee?.isWorkingCurrently === true
                      ? "Çalışıyor"
                      : "Ayrıldı"}
                  </Table.Td>
                  <Table.Td style={{ width: "10%" }}>
                    <Flex justify={"start"} gap={12}>
                      <TableInfoButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          navigate(`${location?.pathname}/${employee?._id}`);
                        }}
                      />
                      <TableEditButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setClickedUser(employee);
                          setOpened(true);
                        }}
                      />
                      <TableDeleteButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setitemToDeleteId(employee?._id);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
        <div
          style={{
            paddingTop: "24px",
          }}
        >
          <CustomPagination
            total={totalPages}
            value={page}
            onChange={setPage}
          />
        </div>
      </div>

      <Modal
        opened={opened}
        title="Çalışan Bilgisi Düzenleme"
        centered
        onClose={() => {
          setOpened(false);
        }}
        withCloseButton={true}
        keepMounted={false}
        key={clickedUser?._id}
      >
        <EmployeesUpdateForm
          closeModal={() => setOpened(false)}
          user={clickedUser}
        />
      </Modal>
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Çalışan Sil"
        text="Bu çalışanı silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </>
  );
};

export default EmployeesTable;

const StyledTableTh = styled(Table.Td)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)`
  cursor: pointer;
  &:hover {
    background: #f1f3f5 !important;
  }
`;

const AvatarText = styled.div`
  color: #21005d;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
`;
